export const GET_USER_DATA = 'GET_USER_DATA';
export const LOGGED = 'LOGGED';
export const LOAD_SESSION = 'LOAD_SESSION';
export const LOAD_USER_DATA = 'LOAD_USER_DATA';
export const SET_FREIGHT_DATA = 'SET_FREIGHT_DATA';


